<template>
  <section>
    <div class="editable-card">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">
            {{ title }}
          </h3>

          <template v-if="editable">
            <a
              v-if="!editing"
              href=""
              title="Edit"
              class="edit-link"
              @click.prevent="setToEditing"
            >
              Edit&nbsp;<span class="fa fa-pencil pl-5 mobile-pl-5" />
            </a>
            <a
              v-else
              href=""
              title="Cancel"
              class="edit-link cancel"
              @click.prevent="cancel"
            > Cancel </a>
          </template>
        </div>

        <hr class="card-title-line">

        <div class="card-content">
          <form
            method="post"
            class="form-horizontal"
            autocomplete="off"
            :class="{ view: !editing }"
            @submit.prevent="save"
          >
            <slot :is-editing="editing" />

            <template v-if="editing">
              <hr class="card-footer-line">

              <div class="form-submit-button-group pb-10 mobile-pb-5">
                <p-button
                  type="purple"
                  round
                  native-type="submit"
                  :disabled="disabled"
                >
                  <slot name="submit-button">
                    Save Changes
                  </slot>
                </p-button>

                <p-button
                  type="yellow"
                  round
                  @click.prevent="cancel"
                >
                  <slot name="cancel-button">
                    Cancel
                  </slot>
                </p-button>
              </div>
            </template>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  editing: {
    type: Boolean,
    required: true,
  },

  editable: {
    type: Boolean,
    default: true,
  },

  title: {
    type: String,
    default: 'Title',
  },

  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['save', 'cancel', 'update:editing']);

const setToEditing = async () => {
  emit('update:editing', true);
};

const cancel = () => {
  emit('update:editing', false);
  emit('cancel');
};

const save = () => {
  emit('save');
};
</script>

<style lang="scss">
.editable-card {
  .card {
    @media (max-width: 576px) {
      margin-bottom: 0;
      .card-content {
        padding: 0 20px 10px;
      }
    }
  }
  .card-header {
    align-items: flex-end;
    .card-title {
      text-align: left !important;
      font-size: 18px !important;
      font-weight: bold !important;
      color: #b1852c !important;
    }
    .edit-link {
      display: flex;
      align-items: center;
      color: #008080;
      font-weight: bold;
      span {
        margin-top: -2px;
      }
      &.cancel {
        color: #f00;
      }
    }
  }
}
</style>
